import React, { useState } from 'react';
import SearchBar from '../components/SearchBar';
import ToolCard from '../components/ToolCard';
import toolRegistry from '../data/toolRegistry.json';
import './AllTools.css';

const AllTools = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const filteredTools = selectedCategory === 'All'
    ? toolRegistry.tools
    : toolRegistry.tools.filter(tool => tool.category === selectedCategory);

  return (
    <div className="all-tools">
      <section className="all-tools-header">
        <h1 className="all-tools-title">All Tools</h1>
        <p className="all-tools-subtitle">
          Browse our complete collection of {toolRegistry.tools.length} developer tools
        </p>
        <SearchBar />
      </section>

      <section className="all-tools-content">
        <div className="category-filter">
          <button
            className={`category-btn ${selectedCategory === 'All' ? 'active' : ''}`}
            onClick={() => setSelectedCategory('All')}
          >
            All
          </button>
          {toolRegistry.categories.map(category => (
            <button
              key={category}
              className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="tools-grid">
          {filteredTools.map(tool => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>

        {filteredTools.length === 0 && (
          <p className="no-tools">No tools found in this category.</p>
        )}
      </section>
    </div>
  );
};

export default AllTools;
